import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { KnowledgeBaseArticle, KnowledgeBaseArticleCreateDto } from '@zayan-erp/home-building';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';

@Injectable({
  providedIn: 'root'
})
export class KnowledgeBaseArticleService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  createArticle(article: KnowledgeBaseArticleCreateDto): Observable<KnowledgeBaseArticle> {
    return this.#http.postData(
      `${this.baseUrl}/KnowledgeBase/articles`,
      { showLoader: true, showMessage: true, message: 'Article created successfully' },
      article
    );
  }

  getArticles(): Observable<KnowledgeBaseArticle[]> {
    return this.#http.getData(`${this.baseUrl}/KnowledgeBase/articles`, { showLoader: true, showMessage: false });
  }

  getArticleById(id: string): Observable<KnowledgeBaseArticle> {
    return this.#http.getData(`${this.baseUrl}/KnowledgeBase/articles/${id}`, { showLoader: true, showMessage: false });
  }

  updateArticle(id: string, article: KnowledgeBaseArticleCreateDto): Observable<KnowledgeBaseArticle> {
    return this.#http.putData(`${this.baseUrl}/KnowledgeBase/articles/${id}`, article, {
      showLoader: true,
      showMessage: true,
      message: 'Article update successfully'
    });
  }

  deleteArticle(id: string): Observable<void> {
    return this.#http.deleteData(`${this.baseUrl}/KnowledgeBase/articles/${id}`, {
      showLoader: true,
      showMessage: true,
      message: 'Article deleted successfully'
    });
  }

  bulkDeleteArticles(ids: string[]): Observable<unknown> {
    return this.#http.postData(
      `${this.baseUrl}/KnowledgeBase/articles/bulk-delete`,
      { showLoader: true, showMessage: true, message: 'Articles deleted successfully' },
      ids
    );
  }
}
